/**
 * Bark推送服务的Node.js SDK
 *
 * @example
 * ```typescript
 * import { BarkClient, createBarkClient, quickPush } from 'bark-sdk';
 *
 * // 创建客户端
 * const client = new BarkClient({
 *   deviceKey: 'your-device-key'
 * });
 *
 * // 发送消息
 * await client.sendText('Hello Bark!', '测试标题');
 *
 * // 或者使用便捷函数
 * await quickPush('your-device-key', 'Hello Bark!', '测试标题');
 * ```
 */

export { BarkClient } from "./bark.js";
export {
  createBarkClient,
  quickPush,
  validateDeviceKey,
  buildPushUrl,
  BarkSounds,
  type BarkSound,
} from "./utils.js";
export type {
  BarkConfig,
  BarkOptions,
  BarkResponse,
  PushRequest,
} from "./types.js";

// 默认导出
import { BarkClient } from "./bark.js";
export default BarkClient;
